NtechApp.ChatMessagesModalForm = function() {
    var me = this;

    me._click = null;

    me._chatMessagesForm = null;

    this._construct = function() {
        me._click = new NtechApp.TouchClickEvent();

        var $form = $("#chatMessagesModalForm .chatMessagesForm");
        me._chatMessagesForm = new NtechApp.ChatMessagesForm($form);

        NtechApp.chatMessagesForm = me._chatMessagesForm;

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerOpenChat]", function(e) {
            var $item = $(e.target).closest("[data-triggerOpenChat]");
            
            if(NtechApp.clientSettings.viewerAccountId == $item.attr("data-triggerOpenChat")) {
                NtechApp.info.on("Can't send message to self.");
                return;
            }

            if(NtechApp.dom.hasAttribute($item.get(0), "data-isViewerAccountInAccountTeam")) {
                var isInAccountTeam = ($item.attr("data-isViewerAccountInAccountTeam") == "1");
                var isBusinessAccount = ($item.attr("data-isViewerAccountInAccountTeam") != "-1");

                if(NtechApp.clientSettings.isPersonal && !isInAccountTeam && isBusinessAccount) {
                    NtechApp.info.on("Only team members can send messages to business accounts.", 2500);
                    return;
                }
            }

            me._chatMessagesForm.openChat($item.attr("data-triggerOpenChat"));
        });

        var onSelectEv = NtechApp.RecentChatsSelectList.EVENT_ITEM_SELECT;
        $(NtechApp.recentChatsSelectList).on(onSelectEv, function(e, chatId) {
            me._chatMessagesForm.openForm(chatId);
        });

        $(NtechApp.chatForm).on(NtechApp.ChatForm.EVENT_NEW_CHAT_MESSAGE, function(e, chatId) {
            me._chatMessagesForm.openForm(chatId);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ChatMessagesModalForm, {

});